import styles from './password-strength-indicator.module.scss'

export type PasswordStrength = 'idle' | 'veryWeak' | 'canImprove' | 'strong'

interface PasswordStrengthIndicatorProps {
  strength: PasswordStrength
}

const labels: Record<PasswordStrength, string> = {
  idle: '',
  veryWeak: 'Muito fraca',
  canImprove: 'Pode melhorar',
  strong: 'Senha forte',
}

const barCounts: Record<PasswordStrength, number> = {
  idle: 3,
  veryWeak: 1,
  canImprove: 2,
  strong: 3,
}

export function PasswordStrengthIndicator({ strength }: PasswordStrengthIndicatorProps) {
  const activeBars = barCounts[strength]
  const label = labels[strength]

  return (
    <div className={styles.container} data-testid="password-strength-indicator">
      <div className={styles.bars}>
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            className={`${styles.bar} ${index < activeBars ? styles.active : styles.inactive} ${
              styles[strength]
            }`}
          />
        ))}
      </div>
      {label && <span className={`${styles.label} ${styles[strength]}`}>{label}</span>}
    </div>
  )
}
